import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import color from "@/style/theme/Color";
import { CardMedia } from "@mui/material";

interface VerticalCardProps {
  path: string | null;
  image: string;
  title: string;
}

const VerticalCard: React.FC<VerticalCardProps> = (props) => {
  return (
    <Card
      href={props.path ?? undefined}
      component="a"
      sx={{
        backgroundColor: color.white,
        height: "100%",
        width: "100%",
        margin: "auto",
        borderRadius: "20px",
        color: color.primary,
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        textDecoration: "none",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
        border: "1px solid rgba(0,0,0,0.03)",
        display: "flex",
        flexDirection: "column",
        ":hover": {
          color: color.primary,
          boxShadow: `0 12px 28px ${color.blue}25`,
          transform: "translateY(-8px)",
          border: `1px solid ${color.blue}50`,
          "& .icon-wrapper": {
            transform: "scale(1.1)",
            backgroundColor: `${color.blue}15`
          }
        },
      }}
    >
      <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 4 }}>
        <Box
          className="icon-wrapper"
          sx={{
            width: "88px",
            height: "88px",
            margin: "0 auto 20px auto",
            backgroundColor: `${color.blue}08`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.3s ease"
          }}
        >
          <Box sx={{ width: "48px", height: "48px" }}>
            <CardMedia
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain"
              }}
              image={props.image}
              title={props.image}
              component="img"
            />
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: "1.125rem",
            fontWeight: 700,
            textAlign: "center",
            lineHeight: 1.4
          }}
        >
          {props.title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default VerticalCard;
